module.exports = __webpack_public_path__ + "media/notificationSound.d1c49648.mp3";